// extracted by mini-css-extract-plugin
export var csatScore = "_ij-5";
export var header = "_ij-1";
export var panelWrapper = "_ij-2";
export var postPreview = "_ij-3";
export var rightContent = "_ij-0";
export var wrappingText = "_ij-4";